import styled from 'styled-components';

import { CustomPurpurTooltip } from '@telialt/common-tooltip/src/CustomPurpurTooltip';

import { Z_INDEX_TOOLTIP } from './constants';

export const Tooltip = styled(CustomPurpurTooltip)`
    z-index: ${Z_INDEX_TOOLTIP};
`;
